import { datadogRum } from '@datadog/browser-rum';
import { postRequest } from '../../../services/DataService';

class DocumentUploadApi {
  static get baseApiUrl() {
    return `${process.env.CARVANA_APP_POST_SALE_DASHBOARD_API_V1}`;
  }

  static async uploadDocument(file: any, tags: any) {
    const data = new FormData();

    data.set('file', file);
    for (let index = 0; index < tags.length; index += 1) {
      data.append(tags[index][0], tags[index][1]);
    }

    try {
      const documentUploadResponse = await postRequest({
        url: `/customercare/postsaledashboard/api/v1/document/upload`,
        data,
        options: { timeout: 0 },
      });
      datadogRum.addAction('PSD API Document Uploaded', {
        fileName: file.name,
      });
      return documentUploadResponse;
    } catch (exception) {
      throw new Error(exception as any);
    }
  }
}

export default DocumentUploadApi;
